<mat-card appearance="outlined">
  @if (isLoading) {
  <mat-progress-bar mode="indeterminate" color="primary" />
  }
  <mat-card-header>
    <mat-card-title>Connection Template</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="flex-column gap-16">
      <!-- Connection Template Section -->
      <div class="flex-column gap-16">
        <mat-form-field>
          <mat-label>Connection Template</mat-label>
          <mat-select [(ngModel)]="selectedTemplate" (selectionChange)="onTemplateChange($event.value)" placeholder="">
            @for (connectionTemplate of connectionTemplates; track connectionTemplate) {
              <mat-option [value]="connectionTemplate.value">
                {{ connectionTemplate.name }}
              </mat-option>
            }
          </mat-select>
          @if (form.get('connectionTemplate')?.hasError('required')) {
            <mat-error>
              Connection template is required.
            </mat-error>
          }
        </mat-form-field>

        <form [formGroup]="form" class="flex-column">
          @for (field of dynamicFields; track field) {
            @if (field.type === 'select') {
            <mat-form-field class="flex-1">
              <mat-label>{{ field.label }}</mat-label>
              <mat-select formControlName="{{ field.formControlName }}">
                @for (option of field.options; track option) {
                <mat-option [value]="option.value">
                  {{ option.name }}
                </mat-option>
                }
              </mat-select>
              @if (form.get(field.formControlName)?.hasError('required')) {
              <mat-error>
                {{ field.label }} is required.
              </mat-error>
              }
            </mat-form-field>
            }
            @if (field.type === 'input') {
            <mat-form-field class="flex-1">
              <mat-label>{{ field.label }}</mat-label>
              <input matInput [type]="field.inputType || 'text'" formControlName="{{ field.formControlName }}"
                placeholder="{{ field.placeholder || '' }}" />
              @if (form.get(field.formControlName)?.hasError('required')) {
              <mat-error>
                {{ field.label }} is required.
              </mat-error>
              }
            </mat-form-field>
            }
          }
        </form>

        <div class="dialog-actions">
          <lib-button variant="raised" color="primary" [disabled]="!validConnection" (buttonClick)="onSave()">Save Connection Template</lib-button>
          <lib-button variant="raised" color="primary" [disabled]="validConnection" (buttonClick)="testConnection()">Test Connection</lib-button>
        </div>

        <div class="indicator">
          @if (validConnection) {
            <div class="success-message">Connection is verified.</div>
          }
          @if (!validConnection) {
            <div class="error-message">Connection is not verified.</div>
          }
        </div>
      </div>

      <!-- Advertiser Consumption Authorization Section -->
      <div class="flex-column gap-16">
        <mat-card-title>Advertiser Consumption Authorization</mat-card-title>
        <mat-form-field>
          <mat-label>API Key</mat-label>
          <input matInput [(ngModel)]="consumptionAuthorization.consumptionApiKey" placeholder="Enter API Key" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>API Secret</mat-label>
          <input matInput [(ngModel)]="consumptionAuthorization.consumptionApiSecret" placeholder="Enter API Secret"
        type="password" />
        </mat-form-field>

        <div class="dialog-actions">
          <lib-button variant="raised" color="primary" (buttonClick)="onSaveConsumptionAuth()">Save API Credentials</lib-button>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
